import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';

export interface CopyMenuItemsPayload {
  srcMenuItemId: string;
  destinationPortalId?: string;
  destinationMenuItemName?: string;
  destinationParentMenuItemId?: string;
  permissions?: string;
  destinationMenuItemSlug?: string;
  destinationMenuItemId?: string;
  destinationPositionType?: string;
  isSyncedCopy?: boolean;
}

export async function postCopyMenuItems(
  payload: Omit<CopyMenuItemsPayload, 'portalServiceUrl' | 'superSecret'>
): Promise<void | Response> {
  try {
    const response = await axiosClient.post(`${generalEnv.nextCommonApiUrl}/portal/menu/copy`, payload, {
      withCredentials: true,
    });
    return response.data;
  } catch (err) {
    console.error('Error in postCopyMenuItems:', err);
    throw new Error('Internal error');
  }
}
